import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 列表
export const setOssFiles: Mutation<IModuleState> = (state, payload) => {
  state.files.data = payload.data;
  state.files.loading = !!payload.loading;
};

// 验证信息
export const setOssPolicy: Mutation<IModuleState> = (state, payload) => {
  state.policy.data = payload.data;
  state.policy.loading = !!payload.loading;
};

// 设置面包屑导航
export const setPathInfo: Mutation<IModuleState> = (state, payload) => {
  state.paths = payload;
};

// 设置当前所在目录路径
export const setSelected: Mutation<IModuleState> = (state, payload) => {
  state.selected = payload;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
  state.confirm.title = payload.title || '';
  state.confirm.content = payload.content || '';
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
